import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';

import { Table,Row,Col,Tooltip,Button,Input,Modal,Divider, Typography,Radio,Space,Form,Switch,notification,AutoComplete,Dropdown,Menu,Select,Layout,Empty,Spin,Checkbox} from 'antd';
import { SettingOutlined,SyncOutlined,DownOutlined,UserOutlined, UnorderedListOutlined, AppstoreOutlined} from '@ant-design/icons';

// import {EditableRow,EditableCell} from './editable';

import Preference from './preference';
// import Examples from 'components/examples';
// import Filters from 'components/filters';
import {UploadContainer} from 'components/upload';
import {useParentState,capitalizeFirstLetter} from 'utils';

import Loading from 'components/loading';
import Pagination from './pagination'

const { Search } = Input;

const SpinContainer=styled.div`
  
  
  display:flex;
  align-items: center;
  justify-content: center;
`

const SpaceContainer=styled(Space)`
  display: flex;
  align-items: center;
  
`


   
export const TableContainer=styled.div`
  overflow: ${({hideOverflow})=>hideOverflow?"hidden":"overlay"};
  padding: 6px;
 .ant-form-item {
  margin-bottom: 0;
  }
 .ant-table-container {
   overflow: overlay;
 }
// .ant-form-item-control-input-content {
//   justify-content: flex-end;
// }
  .editable-cell {
    position: relative;
  }
  
  .editable-cell-value-wrap {
    padding: 5px 12px;
    cursor: pointer;
  }
  
  .editable-row:hover .editable-cell-value-wrap {
    padding: 4px 11px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
  }
 
`;

const Header=styled.div`
 display: flex;
 flex-direction: column;
 align-items: flex-start;
 // justify-content:space-between;
// padding:8px 0;
 // align-items: center;
 
 
    

`;
const PaginationContainer=styled.div`
    justify-content: center;
    display: flex;
    align-items: center;
    
    flex-wrap: wrap;
    gap: 8px
`;




const sortData =(_data,sorter)=>{
  const { field, order,columnKey } = sorter;  
  if(!order)return _data;
  const data = [..._data];
  data.sort((a, b) => {
    const valuea = _.get(a,columnKey) || '';
    const valueb = _.get(b,columnKey) || '';        
    
    if(_.isNumber(valuea)){
      return order === 'ascend'
        ? valueb-valuea
        : valuea-valueb;
    } else{
      return order === 'ascend'
        ? valuea.toString().localeCompare(valueb.toString())
        : valueb.toString().localeCompare(valuea.toString());
    }
  });
  return data;
}

export default ({children,
  viewType:_viewType="table",
  rowKey="id",
  title="",
  loading,
  loadingMore,
  data=[],  
  setData=()=>null,  
  showTitle=false,
  
  actions,
  filters,
  groupFilters,
  fetch=()=>null,
  columns=[],
  
  

  tableComponents,
  newInput,
  expandable,
  showHeader=true,
  showTableHeader=true,
  showActions=true,
  showSeach=true,
  showRefresh=true,
  showPreferences=true,
  showViewType=false,
  visibleColumns:_visibleColumns,
  
  updating=false,
  size="middle",
  searchKey="name",
  hasMore=false,
  Limit=100,
  
  hideOverflow,
  headerStyle={},
  
  isRowSelection,
  selectedRowKeys:_selectedRowKeys,
  setSelectedRowKeys:_setSelectedRowKeys,
  getRowSelection,
  
  setLimit=()=>null,
  onRefresh,
  uploadProps,
  ...other
  })=>{
    
    const [selectedRowKeys,setSelectedRowKeys] = useParentState(_selectedRowKeys,_setSelectedRowKeys);     
    
    
    const [search,setSearch]            = React.useState();
    const [viewType,setViewType]        = React.useState(_viewType);           
    const [isModalOpen,setIsModalOpen]  = React.useState(false);
    const [numberItems,setNumberItems]  = React.useState(Limit);    
    const [sorter,setsorter]            = React.useState();
    const [currentPage, setCurrentPage] = React.useState(1);           
    const [visibleColumns,setVisibleColumns] = React.useState(_visibleColumns);
    
    React.useEffect(()=>{
      setVisibleColumns(_visibleColumns);
    },[_visibleColumns]);
    
    const handleModal         = ()=>setIsModalOpen(!isModalOpen);          
    const handlePageChange    = (page) => setCurrentPage(page);                
    const handleTableChange   = (pagination, filters, sorter) => setsorter(sorter);                       
    
    const onSearch=(_search)=>{   
      const debouncedSearch = _.debounce((value) => setSearch(value), 100);
      debouncedSearch(_search);
    };
    
    const sortedData = React.useMemo(()=>sorter?sortData(data,sorter):data,[sorter,data]);
    
    const {total,currentPageData} = React.useMemo(() =>{        
      const searchData=search?sortedData.filter((o) =>String(o?.[searchKey]).includes(search)):sortedData;       
      const total = searchData.length; // Total number of items
      const startIndex = (currentPage - 1) * numberItems;
      const endIndex = startIndex + numberItems;          
      const currentPageData = searchData.slice(startIndex, endIndex);
      return {total,currentPageData,sortedData};
      
    },[sortedData,search,currentPage,numberItems]);         
    
    
    const visibleColumnsT = visibleColumns || columns.map(o=>o?.visible!=false&&o.key).filter(o=>o!=="undefined")
    const columnsInTable  = visibleColumnsT?columns.filter(o=>Array.isArray(visibleColumnsT)&&(visibleColumnsT.includes(o.key)||o==Table.EXPAND_COLUMN)):columns;    
    
    
    
    return (
      <>
      
      <UploadContainer {...uploadProps} style={{display:"flex",flexDirection:"column",width: "100%"}}>
        {showHeader &&<Header style={headerStyle}>                      
          {showTitle && <Row>
            <Col><Typography.Title level={5} style={{margin:0,padding:0}}>{`${title}`}</Typography.Title></Col>
          </Row>        
          }
          <Row style={{width: "100%",justifyContent: "space-between",paddingBottom:8}} >
            <PaginationContainer>
            {newInput}
            </PaginationContainer>
            
            <PaginationContainer>
              <Pagination currentPage={currentPage} pageSize={numberItems} total={total} onChange={handlePageChange}      />
              { hasMore && <Button loading={loadingMore} type="link" onClick={()=>fetch()}>Load More</Button>}
            </PaginationContainer>
          </Row>
          
          <Row style={{alignItems: "center", justifyContent: "space-between",width: "100%"}}>          
            <Col>
              <Space>
                {showSeach &&<Search placeholder="Search" onChange={(e)=>onSearch(e.target.value)} style={{ width: 200 }} />}
                {showActions && actions}            
              </Space>
            </Col>
  
            <Col style={{display: "flex",alignItems: "center"}}>                
              <SpaceContainer size="small" wrap>
                {showViewType &&          
                  <Radio.Group style={{display:"inline-flex"}}size={"small"} value={viewType} onChange={(e) => setViewType(e.target.value)}>
                    <Radio.Button value="table"><Tooltip title="List View"><UnorderedListOutlined /></Tooltip></Radio.Button>
                    <Radio.Button value="grid"><Tooltip title="Grid View"><AppstoreOutlined /></Tooltip></Radio.Button>
                  </Radio.Group>              
                }
                {filters}
                {groupFilters}
                <SpaceContainer size="small" wrap>
                  <SpinContainer >                  
                  {!loading && showRefresh &&
                    <Tooltip title="Refresh">
                      <Button size="small" type="link" shape="circle" icon={<SyncOutlined />} onClick={()=>(onRefresh&&onRefresh())||fetch({refresh:true})}/>
                    </Tooltip>
                  }
                  </SpinContainer>
                  {showPreferences &&
                    <Tooltip title="Preferences">
                      <Button size="small" type="link" shape="circle" icon={<SettingOutlined />} onClick={handleModal}/>
                    </Tooltip>
                  }
                </SpaceContainer>
              </SpaceContainer>
            </Col>
          </Row>
        </Header>
        }
        
        <TableContainer hideOverflow={hideOverflow}>
          {viewType=="table"?
          <Table 
            
            rowKey={rowKey} 
            expandable={expandable}
            // components={{body: {row: EditableRow,cell: EditableCell}}}
            showHeader={showTableHeader}
            components={tableComponents}
            rowClassName={() => 'editable-row'}
            // rowSelection={getRowSelection({isRowSelection,selectedRowKeys,setSelectedRowKeys,otherData,otherKey,setOtherData})}
            rowSelection={
              isRowSelection?getRowSelection?getRowSelection({selectedRowKeys,setSelectedRowKeys}):{selectedRowKeys,onChange: setSelectedRowKeys}:undefined
            }
            showSorterTooltip={false}          
            pagination={false} 
            
             scroll={{
              // x: 1500,
              
            }}
            size={size}
            loading={loading} 
            dataSource={currentPageData} 
            columns={columnsInTable}
            onChange={handleTableChange}
            {...other}          
            />:
            loading?<Loading transparent/>:
              data.length==0?
              <div><Empty /></div>:
              {/*viewType=="card"?
              <Examples items={data.map(({id,name,metadata:{summary,picture},createdBy,owner,createdAt})=>({title:name, description:summary, image:picture,owner,date:createdAt,url:`/data/${id}`}))} cardType="vertical" handleShowMore={false}/>:
              <Examples items={data.map(({id,name,metadata:{summary,picture},createdBy,owner,createdAt})=>({title:name, description:summary, image:picture,owner,date:createdAt,url:`/data/${id}`}))} cardType="vertical" handleShowMore={false}/>
              */}
              
          }
        </TableContainer>
        
       
        <Preference {...{isModalOpen,columns:columns.filter(o=>o?.key),handleModal,visibleColumns:columns.reduce((acc,o)=>({...acc,[o?.key]:visibleColumnsT.includes(o?.key)}),{}),setVisibleColumns,numberItems,setNumberItems:(e)=>setNumberItems(e.target.value)||setLimit(e.target.value)||setCurrentPage(1)}} />
        {children}
      </UploadContainer>
    </>
  
  )
} 

 // <Layout style={{margin: "12px 24px",flexFlow: "initial",background:"transparent"}}> 
   // </Layout>